import request from '@/utils/request'


// 查询关于我们列表
export function listIntro(query) {
  return request({
    url: '/intro/intro/list',
    method: 'get',
    params: query
  })
}

// 查询关于我们分页
export function pageIntro(query) {
  return request({
    url: '/intro/intro/page',
    method: 'get',
    params: query
  })
}

// 查询关于我们详细
export function getIntro(data) {
  return request({
    url: '/intro/intro/detail',
    method: 'get',
    params: data
  })
}

// 新增关于我们
export function addIntro(data) {
  return request({
    url: '/intro/intro/add',
    method: 'post',
    data: data
  })
}

// 修改关于我们
export function updateIntro(data) {
  return request({
    url: '/intro/intro/edit',
    method: 'post',
    data: data
  })
}

// 删除关于我们
export function delIntro(data) {
  return request({
    url: '/intro/intro/delete',
    method: 'post',
    data: data
  })
}
